import React from 'react';
import {
  Heading,
  Row,
  Column,
  Copy,
  Link,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import { getConfig } from 'src/utilities/config';
import PageSection from 'src/components/enterprise/layout/PageSection';

export default function ManageExemptionCertificates(): JSX.Element {
  const { manageExemptionCertificatesPortalUrl } = getConfig();

  return (
    <Stack y="md">
      <PageSection>
        <Row gutter={0}>
          <Column desktop={9} tablet={8} gutter={0}>
            <Heading variant="h4">Manage your certificates</Heading>
            <Copy variant="body">
              <span>
                You can access and manage your exemption certificates from{' '}
              </span>
              <Link href={manageExemptionCertificatesPortalUrl} target="_blank">
                here
              </Link>
            </Copy>
          </Column>
        </Row>
      </PageSection>
    </Stack>
  );
}
